import { render } from "./iconButton.vue?vue&type=template&id=6cf36c04&scoped=true"
import script from "./iconButton.vue?vue&type=script&lang=js"
export * from "./iconButton.vue?vue&type=script&lang=js"

import "./iconButton.vue?vue&type=style&index=0&id=6cf36c04&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf36c04"]])

export default __exports__